import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { Play as PlaySVG } from '../SVG';
import stylesheet from './Buttons.module.css';

export const ButtonPrimary = addClasses(
  stylesheet.buttonPillShape,
  stylesheet.buttonPrimary
)(ButtonBase);

export const ButtonSecondary = addClasses(
  stylesheet.buttonPillShape,
  stylesheet.buttonSecondary
)(ButtonBase);

export const ButtonPrimaryRaised = raisable()(ButtonPrimary);

export const ButtonSecondaryRaised = raisable()(ButtonSecondary);

export const ButtonTertiary = addClasses(
  stylesheet.buttonPillShape,
  stylesheet.buttonTertiary
)(ButtonBase);

export function Play(props) {
  let { className, color, ...otherProps } = props;
  return (
    <div
      className={cs(stylesheet.buttonBase, stylesheet.play, 'button', {
        [className]: className,
      })}
      {...otherProps}
    >
      <PlaySVG color={color} />
    </div>
  );
}
Play.propTypes = {
  color: PropTypes.string,
};
Play.defaultProps = {
  color: 'white',
};

function ButtonBase(props) {
  let { className, href, onClick, children, ...otherProps } = props;

  let TagName = 'button';
  let role = 'button';
  if (href !== undefined) {
    TagName = 'a';
    role = 'link';
  }

  return (
    <TagName
      role={role}
      href={href}
      onClick={onClick}
      className={cs(stylesheet.buttonBase, 'button', {
        [className]: className,
      })}
      {...otherProps}
    >
      {children}
    </TagName>
  );
}
ButtonBase.propsTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
};
ButtonBase.defaultProps = {
  href: undefined,
  onClick: undefined,
};

function raisable() {
  return function(WrappedComponent) {
    class Raisable extends Component {
      state = {
        down: false,
        inside: false,
      };

      processDown = e => {
        this.setState({ down: true });
      };
      processUp = e => {
        this.setState({ down: false });
      };
      processEnter = e => {
        this.setState(state => ({
          inside: true,
          down: state.down && e.buttons === 1,
        }));
      };
      processExit = e => {
        this.setState({ inside: false });
      };

      mouseDown = e => {
        this.processDown(e);
        if (this.props.onMouseDown) {
          this.props.onMouseDown(e);
        }
      };
      mouseEnter = e => {
        this.processEnter(e);
        if (this.props.onMouseEnter) {
          this.props.onMouseEnter(e);
        }
      };
      mouseLeave = e => {
        this.processExit(e);
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave(e);
        }
      };
      mouseOut = e => {
        this.processExit(e);
        if (this.props.onMouseOut) {
          this.props.onMouseOut(e);
        }
      };
      mouseOver = e => {
        this.processEnter(e);
        if (this.props.onMouseOver) {
          this.props.onMouseOver(e);
        }
      };
      mouseUp = e => {
        this.processUp(e);
        if (this.props.onMouseUp) {
          this.props.onMouseUp(e);
        }
      };
      touchCancel = e => {
        this.processUp(e);
        this.processExit(e);
        if (this.props.onTouchCancel) {
          this.props.onTouchCancel(e);
        }
      };
      touchEnd = e => {
        this.processUp(e);
        this.processExit(e);
        if (this.props.onTouchEnd) {
          this.props.onTouchEnd(e);
        }
      };
      touchStart = e => {
        this.processEnter(e);
        this.processDown(e);
        if (this.props.onTouchStart) {
          this.props.onTouchStart(e);
        }
      };

      render() {
        let { className, ...otherProps } = this.props;

        otherProps.onMouseDown = this.mouseDown;
        otherProps.onMouseEnter = this.mouseEnter;
        otherProps.onMouseLeave = this.mouseLeave;
        otherProps.onMouseOut = this.mouseOut;
        otherProps.onMouseOver = this.mouseOver;
        otherProps.onMouseUp = this.mouseUp;
        otherProps.onTouchCancel = this.touchCancel;
        otherProps.onTouchEnd = this.touchEnd;
        otherProps.onTouchStart = this.touchStart;

        return (
          <WrappedComponent
            className={cs(stylesheet.buttonRaised, {
              [stylesheet.buttonRaisedHover]: this.state.inside,
              [stylesheet.buttonRaisedPressed]:
                this.state.inside && this.state.down,
              [className]: className,
            })}
            {...otherProps}
          />
        );
      }
    }
    Raisable.displayName = getDisplayName(WrappedComponent);
    return Raisable;
  };
}

function addClasses(...classes) {
  return function(WrappedComponent) {
    let wrapper = function(props) {
      let { className, ...otherProps } = props;
      return (
        <WrappedComponent
          className={cs(...classes, { [className]: className })}
          {...otherProps}
        />
      );
    };
    wrapper.displayName = getDisplayName(WrappedComponent);
    return wrapper;
  };
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/components-legacy/Buttons/Buttons.js